import { Badge, Group, Text } from "@mantine/core";

interface LineHeaderProps {
  badgeText: string;
  headerText: string;
}

export const LineHeader = ({ badgeText, headerText }: LineHeaderProps) => {
  return (
    <Group
      style={(theme) => ({
        borderRadius: theme.radius.lg,
        backgroundColor: "#202f37",
        border: "1px solid #555555",
        padding: "0.7rem",
      })}
    >
      <Badge
        variant="filled"
        color="black"
        size="lg"
        radius="lg"
        styles={{ root: { height: "auto", padding: "8px 12px", textTransform: "none" } }}
      >
        {badgeText}
      </Badge>
      <Text fw={500} c="white" size="lg">
        {headerText}
      </Text>
    </Group>
  );
};
